module.exports = __webpack_public_path__ + "static/nur-journey2-edcc9c11e7edc8fc70c6abcf0a9285f3.jpg";